export const statsOptions = [
    { value: "hp", label: "Hp" },
    { value: "attack", label: "Attack" },
    { value: "defense", label: "Defense" },
    { value: "special-attack", label: "Special-attack" },
    { value: "special-defense", label: "Special-defense" },
    { value: "speed", label: "Speed" }
]